/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MapType = {
    GOOGLE: 'GOOGLE',
    DGIS: 'DGIS',
    YANDEX: 'YANDEX'
} as const;
export type MapType = typeof MapType[keyof typeof MapType];

